import axios from 'axios';
import router from '@/router';
import store from '@/store'
import { Loading } from 'element-ui';
import APIs from '@/api'; // 导入APIs
import util from '@/utils/util'
import { Message } from 'element-ui';

// 创建axios实例
const service = axios.create({
  baseURL: "/",
  withCredentials: true, // 携带cookies
});

// 请求拦截器
service.interceptors.request.use(config => {
  // 如果是post请求，设置content-type为json
  config.headers['Authorization'] =  util.getCookie("token") // 让每个请求携带token--['Authorization', 'Bearer 
  console.log("国内为什么没有token", util.getCookie("token"))
  if (config.method === 'post') {
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(response => {
  // 对响应数据做点什么
  return response;
}, error => {
  // 对响应错误做点什么
  return Promise.reject(error);
});

// 创建loading的引用
let loadingInstance;

function safePush(path) {
  if (router.currentRoute.path !== path) {
    router.push(path);
  }
}

// 封装请求函数
function ajax({ type, url, data, fn, errorFn, loading }) {
  return new Promise((resolve, reject) => {
    // 判断如果是海外项目，则url更改为海外api地址
    if(window.location.hash.indexOf("#/abroad") !== -1) {
      url = url.replace("/api", "/abroadApi")
    }
    
    // 创建请求配置
    let requestConfig = {
      method: type,
      url: url,
      data: type === 'get' ? null : data,
      params: type === 'get' ? data : null,
    };



    if (loading) {
      loadingInstance = Loading.service({ lock: true, text: '加载中...' });
    }

    service(requestConfig)
      .then(res => {
        if (loadingInstance) {
          loadingInstance.close();
        }
        if (Number(res.data.code) === 0) {
          resolve(res.data.data)
          fn && fn(res.data.data)
        } else if (Number(res.data.code) === 1) {
          resolve(res.data)
          fn && fn(res.data)
        } else {
          if(Number(res.data.code) === 2000) {
            Message({
              message: res.data.msg,
              type: 'error',
            });
            store.commit('$_removeStorage');
            router.push({path:'/login'});
          } else if(Number(res.data.code) === 2001) {
            let user = JSON.parse(util.getCookie("user"))
            // 如果是海外跳转到海外，国内跳转到国内
            if(user.area == 1) {
              safePush('/app/list');
            } else {
              safePush('/abroad/app/list');

            }
          } else {
              errorfn && errorfn(res.data.msg);
          }
        }
      })
      .catch(err => {
        if (loadingInstance) {
          loadingInstance.close();
        }
        if (axios.isCancel(err)) {
          console.error('Request canceled', err.message);
        } else {
          reject(err);
        }
      });
  });
}


export default {
  getData: (api, params, fn, errorFn, loading) => ajax({ type: 'get', url: APIs[api], data: params, fn, errorFn, loading }),
  postData: (api, data, fn, errorFn, loading) => ajax({ type: 'post', url: APIs[api], data, fn, errorFn, loading }),
  putData: (api, data, fn, errorFn, loading) => ajax({ type: 'put', url: APIs[api], data, fn, errorFn, loading }),
};